import { useSelector } from 'react-redux';

export const useOrderHistory = () => {
    return useSelector(({ orderHistory }) => orderHistory);
};
